



















































import { computed, defineComponent } from "@vue/composition-api";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "PromoteView",
  components: { BaseButton, BaseIcon },
  setup() {
    const { isMember, isCreator, userVerificationStatus } = useAuthUser();

    const hasAppliedForLimited = computed(
      () => isCreator.value && userVerificationStatus.value !== UserVerificationStatus.UNVERIFIED
    );

    const limitedCreatorTitle = computed(() => {
      return isMember.value
        ? $t("Limited Creator")
        : userVerificationStatus.value === UserVerificationStatus.WAITING_FOR_APPROVAL
        ? $t("Sent for approval!")
        : $t("Application approved");
    });

    const limitedCreatorDescription = computed(() => {
      return isMember.value
        ? $t("Network and collaborate. Find creators near you, message, and schedule shoots.")
        : userVerificationStatus.value === UserVerificationStatus.WAITING_FOR_APPROVAL
        ? $t("Your form to be a Limited Creator has been sent and awaiting review.")
        : $t("Your form to be a Limited Creator has been approved.");
    });

    const tags = {
      limitedCreator: [$t("ID verification"), $t("Profile info")],
      fullCreator: [$t("Tax & bank info"), $t("Video uploads"), $t("Participant consent")],
    };

    return {
      tags,
      hasAppliedForLimited,
      limitedCreatorTitle,

      limitedCreatorDescription,
    };
  },
});
